module.exports = {
	"library.footer.terms_of_use": "Gebruiksvoorwaarden",
	"library.footer.terms_and_conditions": "Algemene Voorwaarden",
	"library.footer.privacy_policy": "Privacybeleid",
	"library.footer.get_to_know_us": "Meer over ons",
	"library.footer.about": "Over",
	"library.footer.jobs": "Vacatures",
	"library.footer.blog": "Blog",
	"library.footer.get_help": "Wij helpen je graag",
	"library.footer.find_events": "Zoek evenementen",
	"library.footer.top_events": "Top evenementen",
	"library.footer.host_events": "Host een evenement",
	"library.footer.become_a_host": "Organisator worden",
	"library.footer.tour": "Ontdek",
	"library.footer.embeddable_widgets": "Widgets",
	"library.footer.customers": "Klanten",
	"library.footer.pricing": "Tarieven",
	"library.footer.get_the_onsite_app": "Download de onsite app ",
	"library.footer.developers": "Ontwikkelaars",
	"library.footer.contact_us": "Contact"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/footer/translations/nl.json
// module id = 1583
// module chunks = 0 1 2 3 5 6 7 8 9 10 11 12 13 14 15 16